import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTaskStats = (
    backend: string,
    token: string,
    id: number,
    fromDate: string,
    toDate: string,

) => {
    return fetch(
        `${getApiUrl(backend)}task_stats/${id}?from=${fromDate}&to=${toDate}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTaskStats;
